import { Box, Typography, Link, useTheme } from '@mui/material'
import React from 'react'
import { colors } from 'theme'

// 传入link 优先当作可点击链接处理
interface ToastProps {
  title?: string
  link?: string
  message?: string
  linkText?: string
}

export default function Toast({ title, linkText, message, link }: ToastProps) {
  const theme = useTheme()
  return (
    <Box>
      {link ? (
        <>
          <Typography
            variant="h6"
            color={theme.colors.white}
            fontSize="18px"
            fontWeight={700}
            lineHeight="28px"
            sx={{ wordBreak: 'word-break', fontFamily: "'Roboto', sans-serif" }}
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            color={theme.colors.primary[400]}
            marginTop="4px"
            sx={{ wordBreak: 'word-break', fontFamily: "'Roboto', sans-serif" }}
          >
            {message}
          </Typography>
          <Link
            variant="h6"
            sx={{
              textDecorationColor: theme.colors.white,
              marginTop: '4px',
              fontSize: '16px',
              fontFamily: "'Roboto', sans-serif",
            }}
            color={colors.white}
            href={link}
          >
            {linkText}
          </Link>
        </>
      ) : (
        <>
          <Typography
            variant="h6"
            fontSize="18px"
            lineHeight="28px"
            fontWeight={700}
            color={theme.colors.white}
            sx={{ wordBreak: 'word-break', fontFamily: "'Roboto', sans-serif" }}
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            color={theme.colors.primary[400]}
            sx={{ wordBreak: 'word-break', fontFamily: "'Roboto', sans-serif" }}
          >
            {message}
          </Typography>
        </>
      )}
    </Box>
  )
}

export class Greeting extends React.Component {
  render() {
    return <h1>Hello, 11111</h1>
  }
}
